<template>
    <div id="card">
        <div id="chart">
            <apexchart :type="chartType" height="300" :options="chartOptions" :series="series"></apexchart>
        </div>
    </div>
</template>
<script>
import VueApexCharts from "vue3-apexcharts";
export default {
    props : {
        chartData : {
            type : Object,
            default : () => ({ categories: [], datasets: [] })
        },
        chartType : {
          type : String,
          default : 'bar'
        },
        chartYaxisTitle : {
          type : String,
          default : '# Added',
        },
        formatNumbers : {
          type : Boolean,
          default : true
        }
    },
    components: {
        apexchart : VueApexCharts,
    },
    computed: {
        series() {
            return this.chartData.datasets || [];
        },
        chartOptions() {
            const formatValue = this.formatAmount;
            return {
                chart: {
                    type: this.chartType,
                    height: 350,
                    toolbar: {
                        show: false
                    },
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded'
                    },
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: this.chartType === 'line' ? undefined : ['transparent']
                },
                xaxis: {
                    categories: this.chartData.categories || [],
                    labels: {
                        rotate: -45,
                        rotateAlways: false,
                        style: {
                            fontSize: '11px'
                        }
                    }
                },
                yaxis: {
                    title: {
                        text: this.chartYaxisTitle
                    },
                    labels: {
                        formatter: (val) => {
                            if (this.formatNumbers) {
                                return formatValue(val);
                            }
                            return val;
                        }
                    }
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    y: {
                        formatter: (val) => {
                            if (this.formatNumbers) {
                                return '₦' + formatValue(val);
                            }
                            return (parseInt(val, 10) || 0).toLocaleString('en-US');
                        }
                    }
                },
                colors: ['#17c1e8', '#82d616', '#cb0c9f', '#344767'],
                legend: {
                    position: 'top'
                }
            };
        }
    },
    methods: {
        formatAmount(amount) {
            if (amount === null || amount === undefined) return '0';
            if (amount >= 1000000000) {
                return (amount / 1000000000).toFixed(1) + 'B';
            } else if (amount >= 1000000) {
                return (amount / 1000000).toFixed(1) + 'M';
            } else if (amount >= 1000) {
                return (amount / 1000).toFixed(1) + 'K';
            }
            return amount.toLocaleString();
        }
    }
};
</script>